import { render } from "./ChannelSegmentsForValvePlacement.vue?vue&type=template&id=267ff1c1&ts=true"
import script from "./ChannelSegmentsForValvePlacement.vue?vue&type=script&lang=ts"
export * from "./ChannelSegmentsForValvePlacement.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__